<template>
  <md-dialog :md-active="open" class="modal-close" style="z-index: 10000">
              <span
                class="material-icons close text-right"
                @click="closeModal()"
              >close</span
              >
    <div class="body-modal-course">
      <md-dialog-title>INVITAR SOCIO</md-dialog-title>

      <md-dialog-content class="mt-2">
                  <span
                  >Esto le dara a un nuevo usuario acceso al panel de
                    maquillate como socio.</span
                  ></md-dialog-content
      >

      <md-dialog-content>
        <md-field>
          <div
            class="md-field md-theme-default md-has-placeholder pt-0"
          >
            <md-input
              v-model="email"
              placeholder="Correo electrónico del usuario"
            ></md-input>
          </div>
        </md-field>
      </md-dialog-content>

      <md-dialog-actions>
        <base-button
          class="md-button md-primary md-theme-default"
          @click="closeModal()"
        >CANCELAR
        </base-button
        >
        <base-button
          :loading="isLoading"
          :disabled="!email && isLoading"
          class="md-button md-primary md-theme-default"
          @click="onSubmit()"
        >INVITAR USUARIO
        </base-button
        >
      </md-dialog-actions>
    </div>
  </md-dialog>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';
import validators from 'validator';
import { USER_INVITE_PARTNER } from '@/store/actions/register';

export default {
  name: 'PartnerInviteDialog',
  components: {
    BaseButton,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close-modal', 'success'],
  data () {
    return {
      isLoading: false,
      email: '',
    };
  },
  computed: {
    open: {
      // getter
      get: function() {
        return this.isOpen;
      },
      // setter
      set: function() {
        this.closeModal();
      },
    },
  },
  watch: {},
  mounted () {
  },
  methods: {
    closeModal () {
      this.reset();
      this.$emit('close-modal');
    },
    reset () {
      this.email = '';
      this.isLoading = false;
    },
    sendPartnerInvitation (email) {
      let data = { email };
      this.isLoading = true;
      this.$store
        .dispatch(USER_INVITE_PARTNER, data)
        .then(() => {
          this.$notify({
            type: 'success',
            verticalAlign: 'top',
            horizontalAlign: 'right',
            message: 'Se ha enviado la invitación correctamente.',
          });
          this.isLoading = false;
          this.$emit('success');
          this.$emit('close-modal');
        })
        .catch(() => {
          this.$notify({
            type: 'danger',
            verticalAlign: 'top',
            horizontalAlign: 'right',
            message: 'Tenemos problemas para enviar la invitación',
          });
          this.isLoading = false;
        });
    },
    async onSubmit () {
      const email = this.email;
      if (email && validators.isEmail(email)) {
        this.sendPartnerInvitation(email);
      } else {
        this.$notify({
          type: 'danger',
          verticalAlign: 'top',
          horizontalAlign: 'right',
          message: 'Email inválido',
        });
      }
    },
  },
};
</script>

<style scoped>

</style>